module.exports = __webpack_public_path__ + "static/img/大赛成绩名单2.380c3c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotionList/大赛成绩名单2.jpg
// module id = BmPg
// module chunks = 1